import { makeQuery } from 'shared/utilities';
import { INewsModel } from 'shared/models';

type RequestType = {
    excludeId: number;
}

type ResponseType = {
    items: INewsModel[];
};

export const newsOtherQuery = async function (params: RequestType) {
    return await makeQuery<ResponseType>('/news/other', { params });
}
